import { isArray } from 'lodash-es';

import { DocumentStatus, RequiredDocumentSection } from '@/types/document';
import { User } from '@/types/user';

import { isExistingCustomer } from './user';

const checkBtnDisableForEXC = (
  user: User,
  isNotPendingAndNoDocs: boolean,
  section: RequiredDocumentSection,
) => {
  if (!(user as User).clientReviewed) {
    return true;
  } else {
    if (section.status === DocumentStatus.Approved) {
      return true;
    }
    /**
     * If the EXC has already signed/uploaded section docs then set it true,
     * otherwise set it false
     */
    return isNotPendingAndNoDocs;
  }
};

export const isButtonDisabled = (
  user: User,
  section: RequiredDocumentSection,
) => {
  if (!user) return true;
  const sectionDocs = isArray(section.docs) ? section.docs : [];
  const isNotPendingAndNoDocs =
    section.status !== DocumentStatus.Pending && !sectionDocs.length;
  if (isExistingCustomer(user)) {
    return checkBtnDisableForEXC(user, isNotPendingAndNoDocs, section);
  }

  return isNotPendingAndNoDocs;
};
